import React, { Fragment, useState } from "react";
import { MdCloudUpload, MdDelete, MdCreate } from "react-icons/md";
import { AiFillFileImage } from "react-icons/ai";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import axios from "axios";
import { toast } from "react-toastify";
import { config_url } from "../../config";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  height: "90vh",
  border: "2px solid #000",
  borderRadius: "12px",
  boxShadow: 24,
  overflowY: "scroll",
  p: 4,
};

function UpdBlog({ closeModal, rowCategory, blogs, setBlogs }) {
  const [title, setTitle] = useState(rowCategory.title || "");
  const [metaImage, setMetaImage] = useState(rowCategory.meta_image || "");
  const [description, setDescription] = useState(rowCategory.description || "");
  const [selectedDate, setSelectedDate] = useState(
    rowCategory.date_created || ""
  );
  const [image, setImage] = useState(rowCategory.image || "");
  const [fileName, setFileName] = useState("No selected file");
  const [uploadImage, setUploadImage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleImage = (file) => {
    setUploadImage(true);
    setImage(file);
  };

  const handleChange = async () => {
    if (!title || !description) {
      toast.error("Title and description are required.");
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append("image_blog", image);
    formData.append("oldimage", rowCategory.image);
    formData.append("upload_image", uploadImage);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("date_created", selectedDate);
    formData.append("meta_image", metaImage);

    try {
      const response = await axios.put(
        `${config_url}/api/update-blog/${rowCategory.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        const updatedBlog = response.data;
        setBlogs((prevBlogs) =>
          prevBlogs.map((blog) =>
            blog.id === rowCategory.id ? updatedBlog : blog
          )
        );
        toast.success("Blog updated successfully!");
        closeModal();
      }
    } catch (error) {
      console.error("Error updating blog:", error);
      toast.error(error.response?.data?.message || "Failed to update blog.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      open={true}
      onClose={closeModal}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={style}>
        <Typography variant="h5" gutterBottom>
          Edit Blog
        </Typography>
        <Divider />
        <div className="mt-4">
          <label>Title:</label>
          <textarea
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            rows="4"
            cols="60"
            className="resize rounded-md border border-gray-300 focus:outline-none focus:border-blue-500"
          ></textarea>
        </div>

        <div className="mt-4">
          <TextField
            label="Meta Image"
            value={metaImage}
            onChange={(e) => setMetaImage(e.target.value)}
            fullWidth
          />
        </div>

        <div className="mt-4">
          <label>Date:</label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none"
          />
        </div>

        <div className="mt-4">
          <label>Description:</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows="6"
            cols="80"
            className="resize rounded-md border border-gray-300 focus:outline-none focus:border-blue-500"
          ></textarea>
        </div>

        <div className="mt-4">
          <label>Image:</label>
          <div
            className="border border-dashed border-gray-400 p-4 text-center"
            onClick={() => document.querySelector(".input-field").click()}
          >
            <input
              type="file"
              className="input-field"
              hidden
              onChange={({ target: { files } }) => {
                files[0] && setFileName(files[0].name);
                if (files) handleImage(files[0]);
              }}
            />
            {image ? (
              <img
                src={
                  typeof image === "string" ? image : URL.createObjectURL(image)
                }
                alt={fileName}
                className="w-24 h-24 mx-auto rounded-full"
              />
            ) : (
              <>
                <MdCloudUpload size={40} />
                <p>Click to upload an image</p>
              </>
            )}
          </div>
          <div className="mt-2">
            <AiFillFileImage />
            <span>{fileName}</span>
            <MdDelete
              onClick={() => {
                setImage(null);
                setFileName("No selected file");
              }}
            />
          </div>
        </div>

        <Divider className="my-4" />
        <Button
          variant="contained"
          color="primary"
          startIcon={<MdCreate />}
          onClick={handleChange}
          disabled={isLoading}
        >
          {isLoading ? "Saving..." : "Save"}
        </Button>
      </Box>
    </Modal>
  );
}

export default UpdBlog;
